module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_5"
  }, [_vm._v("AUTHOR’S NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("These adventures were told to me in the old days by Arsène Lupin, as though they had happened to a friend of his, named Prince Rénine. As for me, considering the way in which they were conducted, the actions, the behaviour and the very character of the hero, I find it very difficult not to identify the two friends as one and the same person. Arsène Lupin is gifted with a powerful imagination and is quite capable of attributing to himself adventures which are not his at all and of disowning those which are really his. The reader will judge for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("M. L.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6062bbdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_001.vue
// module id = 75
// module chunks = 0